import { Skeleton } from '../../../Skeleton'
import { BIRDVIEW_ATTENTION_WIDGET_SKELETON_ROWS_COUNT } from '../BirdviewAttentionWidget.constants'

import * as styles from './BirdviewAttentionWidgetSkeleton.module.css'

function BirdviewAttentionWidgetSkeleton() {
  return Array.from(
    { length: BIRDVIEW_ATTENTION_WIDGET_SKELETON_ROWS_COUNT },
    (_, row) => (
      <div className={styles.row} key={row}>
        <Skeleton className={styles.dot} />
        <Skeleton className={styles.reason} />
        <Skeleton className={styles.count} />
        <Skeleton className={styles.arrow} />
      </div>
    )
  )
}

export default BirdviewAttentionWidgetSkeleton
